import type Metric from 'src/AngularJS/Models/metric';
import type MetricData from 'src/AngularJS/Models/metric-data';

export interface GaugeData {
    metrics: GaugeDataItem[];
    Error: number;
    companyGroupTypes: CompanyGroupTypes[];
}

export interface GaugeDataItem {
    metric: Metric;
    metricData: MetricData;
    color: string;
}

export interface CompanyGroupTypes {
    GroupTypeName: string;
    BaseGroupType: ReportGroupType;
    GroupLevel: number;
}

export enum GaugeDirection {
    Up = 0,
    Down = 1,
    SweetSpot = 2,
}

export enum ReportGroupType {
    Employee = "E",
    Contact = "R"
}

export enum ModuleReportType {
    Interval = "INTERVAL",
    Summary = "SUMMARY",
};

export declare class GaugeObject {
    constructor(container: HTMLElement, opts: GaugeOptions);
    container: HTMLElement;
    destroy: () => void;
    error: string | false;
    opts: GaugeOptions;
    setOpts: (opts: GaugeOptions) => void;
    setValue: (value: number) => void;
}

export interface GaugeOptions {
    /** array of breakpoint values */
    breakpoints?: number[];
    /** array of css colors: it will have 1 more item than the breakpoints array
     * null: it will use default colors for 1 to 4 breakpoints
     * when direction is set to 2: 3 colors or null should be used
     */
    colorSegments?: string[];

    /** 0=up, 1=down, 2=Sweet Spot Metric */
    direction?: GaugeDirection;

    /** maximum point on the gauge */
    maxValue?: number;

    /** minimum point on the gauge */
    minValue?: number;

    /** text displayed under the gauge */
    title?: string;

    /** text displayed under the gauge (hover), can be set to null to disable hover */
    titleHover?: string;

    /** text displayed directly under the display value */
    unit?: string;

    /** value as number */
    value?: number;

    /** metric's display value, bypasses the value formatter */
    metricDisplayValue?: string;

    /** function to format values, any number in between values can be passed so it should round if needed */
    valueFormat?: (value: number) => string;

    /** durations of animations in milliseconds (0 to disable) */
    animDurationArc?: number;
    animDurationArcFirst?: number;
    animDurationHover?: number;

    /** size of each arc separation, 'auto' (by breakpointsSeparation) or a specific angle i.e. 2.5 */
    arcSeparator?: number;

    /** value corresponding to each arc separation */
    breakpointsSeparation?: number;

    /** if set to true: hide the gauge marker, skip value animations */
    demo?: boolean;

    /** change between views on mouse hover */
    hover?: boolean;

    /** invert default/hover views */
    hoverInvert?: boolean;

    /** whether to label arc values on the hover view */
    labelRanges?: boolean;

    /** whether to label arc end value on the hover view */
    labelRangesEnd?: boolean;

    /** whether to label arc start value on the hover view */
    labelRangesStart?: boolean;

    /** whether svg should adjust to parent size */
    responsive?: boolean;
}
